import styled from 'styled-components';
import { Input } from 'reactstrap';

export default styled(Input).attrs({ type: 'radio' })`
  margin: 0;
  appearance: none;
  opacity: 0;
`;
